export enum StaffActivityDescriptions {
  AA_MockPortal = "AA Mock Portal",
  AL_BirminghamFireDept = "Birmingham Fire Department Questionaire",
  AL_MorganCountyLEPC = "Morgan County LEPC Questionaire",
  AL_HomewoodFireDept = "Homewood Fire Department Questionaire",
  AR_ArkansasInvoice = "Arkansas Invoice",
  AR_ArkansasPortal = "Arkansas Portal",
  AR_ArkansasTier2Submit = "Arkansas Tier2 Submit",
  AR_ArkansasPortalNewlyNotReporting = "Arkansas Portal Newly Not Reporting",
  AZ_ArizonaPortal = "Arizona State Portal",
  AZ_SendToCustomerToCertify = "Arizona - Send to Customer to Certify",
  AZ_DownloadReport = "Arizona - Download Report",
  CA_CaliforniaPortal = "California State Portal",
  CA_CaliforniaPortalNewlyNotReporting = "California Portal Newly Not Reporting",
  CO_ColoradoSpringsPortal = "Colorado Springs Portal",
  CO_ColoradoTier2Submit = "Colorado Tier2 Submit",
  CO_ColoradoTier2SubmitRevision = "Colorado Tier2 Submit - Revision",
  CT_ConnecticutPortal = "Connecticut State Portal",
  CT_ConnecticutPortalNewlyNotReporting = "Connecticut Portal Newly Not Reporting",
  DC_PerformDCSubmission = "Perform DC submission",
  DE_DelawarePortal = "Delaware State Portal",
  DE_DelawarePortalRevision = "Delaware State Portal - Revision",
  FL_FloridaEPlan = "Florida ePlan",
  FL_Florida312ExemptionForm = "Florida 312 Exemption Form",
  HI_HawaiiTier2Submit = "Hawaii Tier2 Submit",
  ID_IdahoFallsForm = "Idaho Falls Form",
  ID_Idaho312ExemptionForm = "Idaho 312 Exemption Form",
  IL_ChicagoPortal = "Chicago Portal",
  IL_IllinoisPortal = "Illinois State Portal",
  IN_IndianaInvoice = "Indiana Invoice",
  IN_IndianaPortalNewlyNotReporting = "Indiana Portal Newly Not Reporting",
  IN_IndianaPortal = "Indiana State Portal",
  KS_FordCountyLEPC = "Ford County LEPC",
  KS_KansasInvoice = "Kansas Invoice",
  KS_KansasPortal = "Kansas State Portal",
  KS_KansasCityKansasFireDept = "Kansas City, Kansas Fire Dept Portal",
  KS_LenexaFireDeptPortal = "Lenexa Fire Dept Portal",
  KY_KentuckyInvoice = "Kentucky Invoice",
  KY_KentuckyPortal = "Kentucky State Portal",
  LA_EastBatonRougePortal = "East Baton Rouge Portal",
  LA_LouisianaInvoice = "Louisiana Invoice",
  LA_RapidesParishEPC = "Rapides Parish EPC Fees",
  LA_LouisianaPortalNewlyNotReporting = "Louisiana Portal Newly Not Reporting",
  MA_MassachusettsPortal = "Massachusetts State Portal",
  MA_MassachusettsPortalNewlyNotReporting = "Massachusetts Portal Newly Not Reporting",
  MD_HowardPortal = "Howard County Portal",
  MD_MarylandInvoice = "Maryland Invoice",
  MD_MarylandPortal = "Maryland State Portal",
  MD_MarylandPortalNewlyNotReporting = "Maryland Portal Newly Not Reporting",
  MD_MontgomeryPortal = "Montgomery County Portal",
  ME_MaineCertLetterSubjectToEmergencyPlanning = "Maine Certification Letter - Subject to Emergency Planning",
  ME_MaineCertLetterNotSubjectToEmergencyPlanning = "Maine Certification Letter - Not Subject to Emergency Planning",
  MI_MichiganPortal = "Michigan State Portal",
  MI_MichiganPortalNewlyNotReporting = "Michigan Portal Newly Not Reporting",
  MN_MinnesotaPortal = "Minnesota State Portal",
  MN_MinnesotaPortalNewlyNotReporting = "Minnesota Portal Newly Not Reporting",
  MN_MinnesotaPortalRevision = "Minnesota State Portal - Revision",
  MO_MissouriInvoice = "Missouri Invoice",
  MO_MissouriPortal = "Missouri State Portal",
  NC_AlamancePortal = "Alamance County Portal",
  NC_MecklenburgPortal = "Mecklenburg County LEPC",
  NC_NorthCarolinaEPlan = "North Carolina ePlan",
  ND_NorthDakotaInvoice = "North Dakota Invoice",
  ND_NorthDakotaPortal = "North Dakota State Portal",
  ND_NorthDakotaPortalNewlyNotReporting = "North Dakota Portal Newly Not Reporting",
  NE_NebraskaPortal = "Nebraska State Portal",
  NH_NewHampshireTier2Submit = "New Hampshire Tier2 Submit",
  NJ_HowellTownshipFormAndFees = "Howell Township Form and Fees",
  NJ_NewJerseyPortalNewlyNotReporting_ExemptionForm = "New Jersey Portal Exemption Form",
  NJ_NewJerseyPortal = "New Jersey State Portal",
  NM_NewMexicoCoverLetter = "New Mexico Cover Letter",
  NV_NevadaInvoice = "Nevada Invoice",
  NV_NevadaPortal = "Nevada State Portal",
  NV_NevadaPortalNewlyNotReporting = "Nevada Portal Newly Not Reporting",
  NY_NewYorkCityPortal = "New York City Portal",
  NY_NycThresholdReview = "Staff - NYC Threshold Review",
  OH_CityOfCleveland = "City of Cleveland",
  OH_ClevelandFireDept = "Cleveland Fire Department",
  OH_FeeWorksheet = "Ohio Fee Worksheet",
  OH_WadsworthPortal = "City of Wadsworth",
  OH_OhioCertForm = "Ohio Certification Form",
  OH_WarrenPortal = "Warren County Portal",
  OK_OklahomaTier2Submit = "Oklahoma Tier2 Submit",
  OR_OregonPortal = "Oregon State Portal",
  OR_OregonPortalNewlyNotReporting = "Oregon Portal Newly Not Reporting",
  OR_OregonMultnomahCountyLEPC = "Multnomah County LEPC (Portland Water Bureau)",
  PA_BerksPortal = "Berks County Portal",
  PA_CentreCountyInvoice = "Complete Centre County Invoice",
  PA_CrawfordCountyInvoice = "Complete Crawford County Invoice",
  PA_MontgomeryCountyPortal = "Montgomery, PA County Portal",
  PA_PennsylvaniaPortal = "Pennsylvania State Portal",
  PA_PennsylvaniaPortalRevision = "Pennsylvania State Portal - Revision",
  PA_PotterCountyInvoice = "Complete Potter County Invoice",
  PA_PotterCountyLEPC = "Potter County LEPC",
  PA_WashingtonCountyInvoice = "Complete Washington County Invoice",
  PR_PuertoRicoTier2Submit = "Puerto Rico Tier2 Submit",
  RI_RightToKnowAnnualRegistrationForm = "Right-to-Know Annual Registration Form",
  SC_RichlandCountyFormAndFees = "Richland County Form and Fees",
  SD_SouthDakotaPortal = "South Dakota State Portal",
  TX_TexasPortal = "Texas State Portal",
  TX_TexasPortalNewlyNotReporting = "Texas Portal Newly Not Reporting",
  TX_PlanoFireRescuePortal = "Plano Fire-Rescue Portal",
  UT_DavisCountyPortal = "Davis County Portal",
  UT_SaltLakeCityPortal = "Salt Lake City Portal",
  UT_TooelePortal = "Tooele County Portal",
  UT_UtahCountyPortal = "Utah County Portal",
  UT_UtahTier2Submit = "Utah Tier2 Submit",
  VA_CarolineLEPCPortal = "Caroline County LEPC Portal",
  VA_FairfaxPortal = "Fairfax County Portal",
  VA_FredericksburgLEPCPortal = "Fredericksburg LEPC Portal",
  VA_HenricoPortal = "Henrico County Portal",
  VA_KingGeorgeLEPCPortal = "King George County LEPC Portal",
  VA_LynchburgPortal = "City of Lynchburg Portal",
  VA_MecklenburgLEPCPortal = "Mecklenburg County LEPC Portal",
  VA_NewportNewsFireDepartmentPortal = "Newport News Fire Department Portal",
  VA_PeninsulaJointLEPCPortal = "Peninsula Joint LEPC (Newport News)",
  VA_PrinceWilliamCountyPortal = "Prince William County Portal",
  VA_RichmondCityPortal = "Richmond City Portal",
  VA_RoanokeLEPCPortal = "Roanoke Valley Joint LEPC Portal",
  VA_SpotsylvaniaLEPCPortal = "Spotsylvania County LEPC Portal",
  VA_StaffordLEPCPortal = "Stafford County LEPC Portal",
  VA_VirginiaCertLetter = "Virginia Certification Letter",
  VT_VermontTier2Submit = "Vermont Tier2 Submit",
  WA_WashingtonPortal = "Washington State Portal",
  WA_Washington312ExemptionForm = "Washington 312 Exemption Form",
  WI_WisconsinPortal = "Wisconsin State Portal",
  WI_WisconsinPortalRevision = "Wisconsin State Portal - Revision",
  WV_WestVirginiaInvoice = "West Virginia Invoice",
  WV_WestVirginiaPortal = "West Virginia State Portal",
  WV_WestVirginiaPortalNewlyNotReporting = "West Virginia Portal Newly Not Reporting",
  WV_WestVirginiaPortalOilAndGas = "West Virginia State Portal - Oil and Gas",
  WY_WyomingTier2Submit = "Wyoming Tier2 Submit",
}

export const LEGACY_STAFF_ACTIVITY_DESCRIPTIONS = {
  "AA Mock Invoice - Once Per Credential": StaffActivityDescriptions.AA_MockPortal,
  "Alamance County Portal": StaffActivityDescriptions.NC_AlamancePortal,
  "Arizona Portal": StaffActivityDescriptions.AZ_ArizonaPortal,
  "Arizona - Send to Customer to Certify": StaffActivityDescriptions.AZ_SendToCustomerToCertify,
  // Keep for backward compatibility
  "Send to Customer to Certify": StaffActivityDescriptions.AZ_SendToCustomerToCertify,
  "Download Report": StaffActivityDescriptions.AZ_DownloadReport,
  "Arkansas Invoice - Once Per Credential": StaffActivityDescriptions.AR_ArkansasInvoice,
  "Arkansas Portal": StaffActivityDescriptions.AR_ArkansasPortal,
  "Arkansas Portal Newly Not Reporting":
    StaffActivityDescriptions.AR_ArkansasPortalNewlyNotReporting,
  "Arkansas Tier2 Submit": StaffActivityDescriptions.AR_ArkansasTier2Submit,
  "Berks County Portal": StaffActivityDescriptions.PA_BerksPortal,
  "Birmingham Fire Department Questionaire": StaffActivityDescriptions.AL_BirminghamFireDept,
  "California Portal": StaffActivityDescriptions.CA_CaliforniaPortal,
  "California Portal Newly Not Reporting":
    StaffActivityDescriptions.CA_CaliforniaPortalNewlyNotReporting,
  "Caroline County LEPC Portal": StaffActivityDescriptions.VA_CarolineLEPCPortal,
  "Chicago Portal": StaffActivityDescriptions.IL_ChicagoPortal,
  "City of Cleveland": StaffActivityDescriptions.OH_CityOfCleveland,
  "City of Fredericksburg LEPC Portal": StaffActivityDescriptions.VA_FredericksburgLEPCPortal,
  "City of Richmond Portal": StaffActivityDescriptions.VA_RichmondCityPortal,
  "Cleveland Fire Department": StaffActivityDescriptions.OH_ClevelandFireDept,
  "Colorado Springs Portal": StaffActivityDescriptions.CO_ColoradoSpringsPortal,
  "Colorado Tier2 Submit": StaffActivityDescriptions.CO_ColoradoTier2Submit,
  "Colorado Tier2 Submit - Revision": StaffActivityDescriptions.CO_ColoradoTier2SubmitRevision,
  "Connecticut Portal": StaffActivityDescriptions.CT_ConnecticutPortal,
  "Connecticut Portal Newly Not Reporting":
    StaffActivityDescriptions.CT_ConnecticutPortalNewlyNotReporting,
  "Davis County Portal": StaffActivityDescriptions.UT_DavisCountyPortal,
  "Perform DC submission": StaffActivityDescriptions.DC_PerformDCSubmission,
  "Delaware Portal": StaffActivityDescriptions.DE_DelawarePortal,
  "Delaware Portal - Revision": StaffActivityDescriptions.DE_DelawarePortalRevision,
  "East Baton Rouge Portal": StaffActivityDescriptions.LA_EastBatonRougePortal,
  "Fairfax County Portal": StaffActivityDescriptions.VA_FairfaxPortal,
  "Fee Worksheet": StaffActivityDescriptions.OH_FeeWorksheet,
  "Florida ePlan": StaffActivityDescriptions.FL_FloridaEPlan,
  "Florida 312 Exemption Form": StaffActivityDescriptions.FL_Florida312ExemptionForm,
  "Ford County LEPC": StaffActivityDescriptions.KS_FordCountyLEPC,
  "Hawaii Tier2 Submit": StaffActivityDescriptions.HI_HawaiiTier2Submit,
  "Henrico County Portal": StaffActivityDescriptions.VA_HenricoPortal,
  "Homewood Fire Department Questionaire": StaffActivityDescriptions.AL_HomewoodFireDept,
  "Howard County Portal": StaffActivityDescriptions.MD_HowardPortal,
  "Howell Township Form and Fees": StaffActivityDescriptions.NJ_HowellTownshipFormAndFees,
  "Idaho Falls Form": StaffActivityDescriptions.ID_IdahoFallsForm,
  "Idaho 312 Exemption Form": StaffActivityDescriptions.ID_Idaho312ExemptionForm,
  "Illinois Portal": StaffActivityDescriptions.IL_IllinoisPortal,
  "Indiana Invoice - Once Per Credential": StaffActivityDescriptions.IN_IndianaInvoice,
  "Indiana Portal": StaffActivityDescriptions.IN_IndianaPortal,
  "Indiana Portal Newly Not Reporting": StaffActivityDescriptions.IN_IndianaPortalNewlyNotReporting,
  "IN Newly Not Reporting Staff Step": StaffActivityDescriptions.IN_IndianaPortalNewlyNotReporting,
  "Kansas City, Kansas Fire Dept Portal": StaffActivityDescriptions.KS_KansasCityKansasFireDept,
  "Kansas Invoice - Once Per Credential": StaffActivityDescriptions.KS_KansasInvoice,
  "Kansas Portal": StaffActivityDescriptions.KS_KansasPortal,
  "Kentucky Invoice - Once Per Credential": StaffActivityDescriptions.KY_KentuckyInvoice,
  "Kentucky Portal": StaffActivityDescriptions.KY_KentuckyPortal,
  "King George County LEPC Portal": StaffActivityDescriptions.VA_KingGeorgeLEPCPortal,
  "Lenexa Fire Dept Portal": StaffActivityDescriptions.KS_LenexaFireDeptPortal,
  "Louisiana Invoice - Once Per Credential": StaffActivityDescriptions.LA_LouisianaInvoice,
  "Louisiana Portal Newly Not Reporting":
    StaffActivityDescriptions.LA_LouisianaPortalNewlyNotReporting,
  "LA Newly Not Reporting Staff Step":
    StaffActivityDescriptions.LA_LouisianaPortalNewlyNotReporting,
  "Maine Certification Letter - Subject to Emergency Planning":
    StaffActivityDescriptions.ME_MaineCertLetterSubjectToEmergencyPlanning,
  "Maine Certification Letter - Not Subject to Emergency Planning":
    StaffActivityDescriptions.ME_MaineCertLetterNotSubjectToEmergencyPlanning,
  "Maryland Invoice - Once Per Credential": StaffActivityDescriptions.MD_MarylandInvoice,
  "Maryland Portal": StaffActivityDescriptions.MD_MarylandPortal,
  "Maryland Portal Newly Not Reporting":
    StaffActivityDescriptions.MD_MarylandPortalNewlyNotReporting,
  "MD Newly Not Reporting Staff Step": StaffActivityDescriptions.MD_MarylandPortalNewlyNotReporting,
  "Massachusetts Portal": StaffActivityDescriptions.MA_MassachusettsPortal,
  "Massachusetts Portal Newly Not Reporting":
    StaffActivityDescriptions.MA_MassachusettsPortalNewlyNotReporting,
  "MA Newly Not Reporting Staff Step":
    StaffActivityDescriptions.MA_MassachusettsPortalNewlyNotReporting,
  "Mecklenburg County LEPC": StaffActivityDescriptions.NC_MecklenburgPortal,
  "Michigan Portal": StaffActivityDescriptions.MI_MichiganPortal,
  "Michigan Portal Newly Not Reporting":
    StaffActivityDescriptions.MI_MichiganPortalNewlyNotReporting,
  "MI Newly Not Reporting Staff Step": StaffActivityDescriptions.MI_MichiganPortalNewlyNotReporting,
  "Minnesota Portal": StaffActivityDescriptions.MN_MinnesotaPortal,
  "Minnesota Portal Newly Not Reporting":
    StaffActivityDescriptions.MN_MinnesotaPortalNewlyNotReporting,
  "MN Newly Not Reporting Staff Step":
    StaffActivityDescriptions.MN_MinnesotaPortalNewlyNotReporting,
  "Minnesota Portal - Revision": StaffActivityDescriptions.MN_MinnesotaPortalRevision,
  "Missouri Invoice - Once Per Credential": StaffActivityDescriptions.MO_MissouriInvoice,
  "Missouri Invoice - Once Per Company": StaffActivityDescriptions.MO_MissouriInvoice,
  "Missouri Portal": StaffActivityDescriptions.MO_MissouriPortal,
  "Montgomery County Portal": StaffActivityDescriptions.MD_MontgomeryPortal,
  "Morgan County LEPC Questionaire": StaffActivityDescriptions.AL_MorganCountyLEPC,
  "Nebraska Portal": StaffActivityDescriptions.NE_NebraskaPortal,
  "Nevada Invoice - Once Per Credential": StaffActivityDescriptions.NV_NevadaInvoice,
  "Nevada Portal": StaffActivityDescriptions.NV_NevadaPortal,
  "Nevada Portal Newly Not Reporting": StaffActivityDescriptions.NV_NevadaPortalNewlyNotReporting,
  "NV Newly Not Reporting Staff Step": StaffActivityDescriptions.NV_NevadaPortalNewlyNotReporting,
  "New Hampshire Tier2 Submit": StaffActivityDescriptions.NH_NewHampshireTier2Submit,
  "New Jersey Portal": StaffActivityDescriptions.NJ_NewJerseyPortal,
  "New Jersey Portal Exemption Form":
    StaffActivityDescriptions.NJ_NewJerseyPortalNewlyNotReporting_ExemptionForm,
  "New Mexico Cover Letter - Once Per Organization":
    StaffActivityDescriptions.NM_NewMexicoCoverLetter,
  "New York City Portal": StaffActivityDescriptions.NY_NewYorkCityPortal,
  "Staff - NYC Threshold Review": StaffActivityDescriptions.NY_NycThresholdReview,
  "Newport News Fire Department Portal":
    StaffActivityDescriptions.VA_NewportNewsFireDepartmentPortal,
  "North Carolina ePlan": StaffActivityDescriptions.NC_NorthCarolinaEPlan,
  "North Dakota Invoice - Once Per Credential": StaffActivityDescriptions.ND_NorthDakotaInvoice,
  "North Dakota Portal": StaffActivityDescriptions.ND_NorthDakotaPortal,
  "North Dakota Portal Newly Not Reporting":
    StaffActivityDescriptions.ND_NorthDakotaPortalNewlyNotReporting,
  "Ohio Certification Form": StaffActivityDescriptions.OH_OhioCertForm,
  "Oklahoma Tier2 Submit - Once Per Credential": StaffActivityDescriptions.OK_OklahomaTier2Submit,
  "Oregon Portal": StaffActivityDescriptions.OR_OregonPortal,
  "Oregon Portal Newly Not Reporting": StaffActivityDescriptions.OR_OregonPortalNewlyNotReporting,
  "Multnomah County LEPC (Portland Water Bureau)":
    StaffActivityDescriptions.OR_OregonMultnomahCountyLEPC,
  "Peninsula Joint LEPC (Newport News)": StaffActivityDescriptions.VA_PeninsulaJointLEPCPortal,
  "Montgomery, PA County Portal": StaffActivityDescriptions.PA_MontgomeryCountyPortal,
  "Pennsylvania Portal": StaffActivityDescriptions.PA_PennsylvaniaPortal,
  "Pennsylvania Portal - Revision": StaffActivityDescriptions.PA_PennsylvaniaPortalRevision,
  "Potter County LEPC": StaffActivityDescriptions.PA_PotterCountyLEPC,
  "Complete Centre County Invoice": StaffActivityDescriptions.PA_CentreCountyInvoice,
  "Complete Crawford County Invoice": StaffActivityDescriptions.PA_CrawfordCountyInvoice,
  "Complete Potter County Invoice": StaffActivityDescriptions.PA_PotterCountyInvoice,
  "Complete Washington County Invoice": StaffActivityDescriptions.PA_WashingtonCountyInvoice,
  "Prince William County Portal": StaffActivityDescriptions.VA_PrinceWilliamCountyPortal,
  "Puerto Rico Tier2 Submit": StaffActivityDescriptions.PR_PuertoRicoTier2Submit,
  "Rapides Parish EPC Fees": StaffActivityDescriptions.LA_RapidesParishEPC,
  "Right-to-Know Annual Registration Form":
    StaffActivityDescriptions.RI_RightToKnowAnnualRegistrationForm,
  "Richland County Form and Fees": StaffActivityDescriptions.SC_RichlandCountyFormAndFees,
  "Roanoke Valley Joint LEPC Portal": StaffActivityDescriptions.VA_RoanokeLEPCPortal,
  "Salt Lake City Portal": StaffActivityDescriptions.UT_SaltLakeCityPortal,
  "South Dakota Portal": StaffActivityDescriptions.SD_SouthDakotaPortal,
  "Spotsylvania County LEPC Portal": StaffActivityDescriptions.VA_SpotsylvaniaLEPCPortal,
  "Stafford County LEPC Portal": StaffActivityDescriptions.VA_StaffordLEPCPortal,
  "City of Lynchburg Portal": StaffActivityDescriptions.VA_LynchburgPortal,
  "Mecklenburg County LEPC Portal": StaffActivityDescriptions.VA_MecklenburgLEPCPortal,
  "Texas Portal - Once Per CN": StaffActivityDescriptions.TX_TexasPortal,
  "Texas Portal Newly Not Reporting": StaffActivityDescriptions.TX_TexasPortalNewlyNotReporting,
  "Plano Fire-Rescue Portal": StaffActivityDescriptions.TX_PlanoFireRescuePortal,
  "Tooele County Portal": StaffActivityDescriptions.UT_TooelePortal,
  "Utah County Portal": StaffActivityDescriptions.UT_UtahCountyPortal,
  "Utah Tier2 Submit": StaffActivityDescriptions.UT_UtahTier2Submit,
  "Vermont Tier2 Submit": StaffActivityDescriptions.VT_VermontTier2Submit,
  "Virginia Certification Letter": StaffActivityDescriptions.VA_VirginiaCertLetter,
  "Warren County Portal": StaffActivityDescriptions.OH_WarrenPortal,
  "City of Wadsworth": StaffActivityDescriptions.OH_WadsworthPortal,
  "Washington Portal": StaffActivityDescriptions.WA_WashingtonPortal,
  "Washington 312 Exemption Form": StaffActivityDescriptions.WA_Washington312ExemptionForm,
  "West Virginia Invoice - Once Per Credential": StaffActivityDescriptions.WV_WestVirginiaInvoice,
  "West Virginia Portal": StaffActivityDescriptions.WV_WestVirginiaPortal,
  "West Virginia Portal Newly Not Reporting":
    StaffActivityDescriptions.WV_WestVirginiaPortalNewlyNotReporting,
  "WV Newly Not Reporting Staff Step":
    StaffActivityDescriptions.WV_WestVirginiaPortalNewlyNotReporting,
  "West Virginia Portal - Oil and Gas": StaffActivityDescriptions.WV_WestVirginiaPortalOilAndGas,
  "Wisconsin Portal": StaffActivityDescriptions.WI_WisconsinPortal,
  "Wisconsin Portal - Revision": StaffActivityDescriptions.WI_WisconsinPortalRevision,
  "Wyoming Tier2 Submit": StaffActivityDescriptions.WY_WyomingTier2Submit,
};

export type LegacyDescription = keyof typeof LEGACY_STAFF_ACTIVITY_DESCRIPTIONS;
